<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      persistent
    >
      <v-card tile class="d-flex flex-column justify-center align-center">
        <h1 class="text-h2 my-5">Login Error</h1>
        <h3 class="font-weight-light mb-5 grey--text text--darken-2">
          การเข้าสู่ระบบของคุณมีปัญหา กรุณาลองใหม่อีกครั้ง
        </h3>
        <v-btn large color="primary" class="my-5" @click="handleLogin">
          เข้าสู่ระบบ อีกครั้ง
        </v-btn>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { generateCodeChallenge, generateCodeVerifier } from '../utils/auth'

export default {
  data() {
    return {
      dialog: true,
    }
  },
  methods: {
    async handleLogin() {
      var code_verifier = generateCodeVerifier()
      var code_challenge = generateCodeChallenge(code_verifier)

      window.localStorage.setItem('code_verifier', code_verifier)
      window.localStorage.setItem('code_challenge', code_challenge)

      const state = 'random-value'
      const code_challenge_method = 'S256'

      const authEndpoint = process.env.VUE_APP_AUTH_ENDPOINT
      const authType = process.env.VUE_APP_AUTH_TYPE
      const authResponseType = process.env.VUE_APP_AUTH_RESPONSE_TYPE
      const authClientID = process.env.VUE_APP_AUTH_CLIENT_ID

      const redirectUri =
        process.env.VUE_APP_MODE === 'development'
          ? 'http://localhost:8080/login-callback' // TODO: when upto could change to process.env.VUE_APP_AUTH_REDIRECT_URI
          : process.env.VUE_APP_AUTH_REDIRECT_URI

      window.location.replace(
        `${authEndpoint}${authType}?response_type=${authResponseType}&client_id=${authClientID}&state=${state}&code_challenge=${code_challenge}&code_challenge_method=${code_challenge_method}&redirect_uri=${redirectUri}`
      )
    },
  },
}
</script>
